<template>
  <div class="c-main">
    <div
      class="banner"
      :style="{
        backgroundImage: `url('${BASE_URL}${customerHeader.url}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
      }"
    >
      <div class="banner-container">
        <h1 class="banner-title">客户案例</h1>
        <div class="banner-desc" v-html="customerHeader.content"></div>
      </div>
      <div class="breadcrumb">
        <span @click="$router.push('/')">首页</span>
        <span class="separator">/</span>
        <span>客户案例</span>
      </div>
    </div>
    <div class="solution-page">
      <!-- 解决方案列表 -->
      <div class="solution-list">
        <div
          class="solution-card"
          v-for="(item, index) in newsList"
          :key="item.id"
        >
          <!-- 卡片图片 -->
          <div class="card-img">
            <img
              :src="BASE_URL + item.infoImage"
              :alt="item.title"
              class="solution-img"
              loading="lazy"
            />
          </div>

          <!-- 卡片内容 -->
          <div class="card-content">
            <h3 class="card-title">{{ item.infoTitle }}</h3>
            <p class="card-desc">{{ item.infoContent | setText }}</p>
            <span class="view-detail" @click="goToDetail(item)"
              >查看详情 →</span
            >
          </div>
        </div>
      </div>

      <!-- Element UI 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalCount"
          layout="prev, pager, next, jumper"
          background
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import { getArticle } from "../../api/article";
// import ArticleItem from "../Components/ArticleItem";
import { listInfo, getConf } from "../../api/article";

export default {
  name: "productCenter",
  data() {
    return {
      allNews: [],
      customerHeader: {},
      BASE_URL: process.env.VUE_APP_API_BASE_URL,
      currentPage: 1, // 当前页码
      pageSize: 9, // 每页显示9条
      totalCount: 0, // 总数据量
      newsList: [], // 解决方案列表
    };
  },
  filters: {
    setText(val) {
      return val
        .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, "\n")
        .replace(/<br\/?>/gi, "\n")
        .replace(/<[^>/]+>/g, "")
        .replace(/(\n)?<\/([^>]+)>/g, "")
        .replace(/\u00a0/g, " ")
        .replace(/&nbsp;/g, " ")
        .replace(/<img[^>]+src\\s*=\\s*['\"]([^'\"]+)['\"][^>]*>/g, "")
        .replace(/<\/?(img|table)[^>]*>/g, "") // 去除图片和表格
        .replace(/<\/?(a)[^>]*>/g, ""); //  去除a标签
    },
  },
  computed: {},
  created() {},
  mounted() {
    this.fetchHomeConf();
    this.fetchNewsData();
  },
  methods: {
    async fetchHomeConf() {
      try {
        const response = await getConf();
        this.customerHeader = JSON.parse(response.data.customerHeader) || {};
      } catch (error) {
        console.error("页面初始化获取配置失败", error);
      }
    },
    goToDetail(item) {
      this.$router.push({ path: `/newdetails/${item.infoId}`,  query: { type: 'customer', } });
    },
    handlePageChange(page) {
      this.currentPage = page;
      // 关键修改：替换原 this.fetchNewsData()，直接前端拆分数据
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.newsList = this.allNews.slice(start, end);
      // 保留滚动到顶部逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    // 卡片点击事件
    handleCardClick(id) {
      // 跳转到详情页
      this.$router.push(`/solutions/detail/${id}`);
    },

    // 接口请求方法（预留）
    async fetchNewsData() {
      try {
        const requestParams = {
          pageNum: 1,
          numPerPage: 999,
        };
        const res = await listInfo(requestParams, { infoType: 4 });
        if (res.code == 0) {
          this.allNews = res.rows; // 存储所有数据（10条）
          this.totalCount = res.total;
          // 新增：调用前端分页拆分
          const start = (this.currentPage - 1) * this.pageSize;
          const end = start + this.pageSize;
          this.newsList = this.allNews.slice(start, end);
          this.totalCount = res.total;
        } else {
          this.allNews = [];
          this.newsList = [];
          this.totalCount = 0;
          this.$message.warning("未获取到新闻数据");
        }
      } catch (error) {
        console.error("新闻数据请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
        this.newsList = [];
        this.allNews = [];
        this.totalCount = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100%;
}

.c-main {
  min-height: calc(100vh - 100px);
}
.banner {
  width: 100%;
  height: 450px;
  @include backgroundImage("../../assets/custorbanner.png");
  position: relative;
  .banner-container {
    position: absolute;
    left: 300px; // 距离左侧边距
    top: 177px;
    transform: translateY(-50%);
    color: #fff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .banner-title {
      font-size: 48px;
      font-weight: bold;
      margin: 0 0 20px;
      line-height: 1.2;
    }

    .banner-desc {
      font-size: 16px;
      margin: 0 0 16px;
      opacity: 0.9;
      max-width: 1200px;
    }
  }
  .breadcrumb {
    position: absolute;
    left: 300px; // 距离左侧边距
    bottom: 24px;
    font-size: 12px;
    opacity: 0.8;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    span {
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }

    .separator {
      cursor: default;
      opacity: 0.6;
    }
  }
}
.solution-page {
  background-color: #ffffff;
  padding: 60px 20px;
  box-sizing: border-box;
}

// 解决方案列表
.solution-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); // 3列布局，适配9条数据
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto 50px;
}

// 解决方案卡片
.solution-card {
  background: linear-gradient(180deg, #f4f5fa 0%, #fefeff 100%);
  box-shadow: 0px 6px 8px 1px rgba(115, 154, 188, 0.16);
  border-radius: 16px 16px 16px 16px;
  border: 4px solid #ffffff;
  cursor: pointer;
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }

  .card-img {
    width: 100%;
    height: 200px;
    overflow: hidden;

    .solution-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;

      &:hover {
        transform: scale(1.08);
      }
    }
  }

  .card-content {
    padding: 20px;

    .card-title {
      font-size: 18px;
      color: #000a25;
      margin: 0 0 12px;
      font-weight: 600;
    }

    .card-desc {
      font-size: 14px;
      color: #666;
      margin: 0 0 16px;
      line-height: 1.6;
      display: -webkit-box;
      -webkit-line-clamp: 2; // 限制显示2行
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .view-detail {
      position: absolute;
      bottom: 12px;
      right: 20px;
      font-size: 14px;
      color: #005cef;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      transition: color 0.3s;

      &:hover {
        color: #0047cc;
      }
    }
  }
}

// 分页容器
.pagination-container {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

// Element UI分页样式调整
::v-deep .el-pagination {
  padding-top: 10px;

  .el-pagination__button {
    border-radius: 4px;
  }

  .el-pagination__active {
    background-color: #005cef;
    border-color: #005cef;
  }

  .el-pager li {
    margin: 0 5px;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
  }
}
</style>
